export default (function (value) {
  return typeof value === 'function';
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-actions/es/utils/isFunction.js
// module id = ./node_modules/redux-actions/es/utils/isFunction.js
// module chunks = 6 9 11